// Called by : src/App.vue (select-user)

<template>
    <div class="dropdown">

        <button class="btn btn-outline-light dropdown-toggle py-2 px-4 txt_ombre_333 txt_size_125" role="button" id="dropdownMenuUser" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="oi oi-person pr-2"></span>
            <span class="">{{ user.login }}</span>
        </button>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuUser">

            <a v-if="isApr" href="" id="nav_pge_apr" class="dropdown-item" data-toggle="modal" data-target="#pge_apr">
              <span class="oi oi-person pr-2"></span>
              <span id="nav_pge_apr_nme">{{ sNameFull }}…</span>
            </a>
            
            <div v-else id="nav_user_name" class="dropdown-item">
              <span class="oi oi-person pr-2"></span>
              {{ sNameFull }}
            </div>

            <a v-if="isSign" href="" id="nav_pge_sign" class="dropdown-item" data-toggle="modal" data-target="#pge_sign">
                <span class="oi oi-pencil mr-2"></span>
                {{ $t('infos.sign') }}
            </a>
            
            <div id="nav_logout" class="dropdown-item text-center">
              <button class="btn btn-primary py-2 px-4" @click="logout">
                <span class="oi oi-power-standby mr-2"></span>
                {{ $t('common.logout') }}
              </button>
            </div>

        </div>

      {{ forceRefresh }}

  </div> <!-- .dropdown -->
</template>

<script>
export default {
  data() {
    return {
      isSign: false,
      isApr: false,
      sNameFull: '',
    }
  },
  methods: {
    logout() {
      this.$router.push({name: 'connect'})
    },
  },
  computed: {
    forceRefresh() {
      this.isSign = this.params.isSignature;
      this.isApr = this.params.isAprEditDatas;
      this.sNameFull = this.user.fullName;
      return '';
    },
    user() {
      return this.$store.state.user
    },
    params() {
      return this.$store.state.params
    },  
  }
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/header/SelectUser.vue